import Vue from 'vue'
const contexts = require.context('.', false, /\.vue$/)
contexts.keys().forEach(key => {
    const component = contexts(key).default
    Vue.component(component.name, component)
})